import Title from "@/components/mobile/mobile-raise/Title.vue";

export const Constants = {
	DEFAULT_CAMERA_SETTINGS_META: "<Camera><Qual>Lowest</Qual><TelemServerID>0</TelemServerID><TelemSpeed>Default</TelemSpeed><TelemQual>Default</TelemQual><Presets /></Camera>"
} as const;

export const DevicesMaxLength = {
	Title: 250
} as const;
